import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { get } from 'lodash';
import { View } from '@zhike/ti-ui';
import { getReport } from 'common/apis';
import { getToken } from 'utils/action';
import { handleAnswer } from 'utils';
import styles from './styles';

const dimensionObj = {
  Reading: '阅读',
  Listening: '听力',
  Speaking: '口语',
  Writing: '写作',
  Vocabulary: '词汇',
  Grammar: '语法',
};
const questionTypeObj = {
  ChooseOne: '单选题',
  ChooseMany: '多选题',
  Blank: '填空题',
  SubjectBlank: '填空题',
  Speaking: '口语题',
  Writing: '写作题',
  FollowUp: '跟读题',
};

function Workbook() {
  if (!(this instanceof Workbook)) { return new Workbook(); }
  this.SheetNames = [];
  this.Sheets = {};
}
// 结束
export default class ExportAnswer extends Component {
  // 参数
  static propTypes = {
    exerciseId: PropTypes.number.isRequired,
    className: PropTypes.any,
    isFull: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    className: undefined,
  }

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  async getData() {
    if (this.state.isLoading) return false;
    this.setState({ isLoading: true });
    const report = await axios({
      url: getReport[1].replace(/@mode/, this.props.isFull === 'true' ? 'full-test' : 'test'),
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        From: 1,
      },
      params: {
        token: getToken(),
        exerciseId: this.props.exerciseId,
        practiceDetail: 1,
      },
    });
    this.handleReportData(report.data);
  }

  // 处理data数据
  async handleReportData(data) {
    const { practices, name } = data.data.practicePackage;
    const excelData = [['科目', '题号', '题型', '正确答案', '用户答案', '正误判断']];
    practices.forEach(practice => {
      const { questions, dimension } = practice;
      let num = 0;
      const subject = dimensionObj[dimension];
      questions.forEach(question => {
        const { type } = question;
        num += 1;
        let excelAnswer = '';
        let excelUserAnswer = '';
        let excelCorrect = '';
        if (type === 'Speaking' || type === 'FollowUp') {
          excelUserAnswer = get(question, 'materials.0.userAnswer.answer.src') || '-';
        } else if (type === 'Writing') {
          excelUserAnswer = get(question, 'materials.0.userAnswer.answer.text') || '-';
        } else {
          const { answer, userAnswer, isCorrect } = handleAnswer(question.materials, question.type);
          excelAnswer = answer;
          excelUserAnswer = userAnswer || '-';
          if (Array.isArray(userAnswer)) {
            excelUserAnswer = userAnswer.join(',');
          }
          if (Array.isArray(isCorrect)) {
            excelCorrect = [];
            isCorrect.forEach(item => {
              excelCorrect.push(item ? '对' : '错');
            })
            excelCorrect = excelCorrect.join(',');
          } else {
            excelCorrect = isCorrect ? '对' : '错';
          }
        }
        excelData.push([
          subject,
          num,
          questionTypeObj[type],
          excelAnswer,
          excelUserAnswer,
          excelCorrect,
        ]);
      })
    });
    console.log(excelData, 'excelData', name);
    await this.createExcelFile({ fileName: `${name}.xlsx`, data: excelData });
    this.setState({ isLoading: false });
  }

  s2ab = s => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);

    // eslint-disable-next-line no-bitwise
    for (let i = 0; i !== s.length; i += 1) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  createExcelFile = data => {
    const wb = new Workbook();
    const sheetName = 'template';

    const ws = XLSX.utils.aoa_to_sheet(data.data);
    wb.SheetNames.push(sheetName);
    wb.Sheets[sheetName] = ws;

    const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    const blob = new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }); // eslint-disable-line
    saveAs(blob, data.fileName);
  }

  // 渲染
  render() {
    const { isLoading } = this.state;
    const newStyles = [styles.exportAnswer, this.props.className];
    if (!isLoading) newStyles.push(styles.exportAnswerHover);
    if (isLoading) newStyles.push(styles.exportAnswerLoading);
    return (
      <View className={newStyles} onClick={() => this.getData()}>
        {isLoading ? '正在导出...' : '导出答案'}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/export_answer.js